const createLink = (email: string, headers?: any) => {
  let link = `mailto:${email}`;
  if (headers) {
    link += `?${toSearchString(headers)}`;
  }
  return link;
};

const toSearchString = (searchParams: any) =>
  typeof searchParams === 'object' &&
  Object.keys(searchParams)
    .map((key) => `${key}=${encodeURIComponent(searchParams[key])}`)
    .join('&');

const MailToUtils = {
  createLink,
  toSearchString,
};

export default MailToUtils;
